import React from 'react'
import PropTypes from 'prop-types'
import Page from '../../containers/RecuperarContrasena'

const RecuperarContrasena = () => (
    <React.Fragment>
        <Page />
    </React.Fragment>
)

RecuperarContrasena.propTypes = {
    children: PropTypes.node
}

export default RecuperarContrasena